export default __webpack_public_path__ + "static/media/4.e0d2fe7c.jpg";